import React from 'react';
import styled from '@tanium/react-emotion';
import { css } from '@tanium/style-system';
import { ThemeColors } from '@tanium/theme-data';
import { Radio } from '@tanium/react-radio';
import { Stack } from '@tanium/react-stack';
import { MediumBoldText, SmallSubtleText } from '../../TextStyles';

export const IdpScope = {
  Account: 'account',
  Console: 'console',
} as const;
export type IdpScopeValue = (typeof IdpScope)[keyof typeof IdpScope];

// The selected option gets a 2px border and 1px less padding so the content never shifts between states.
// eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
const Option = styled('label')(({ isSelected }: { isSelected: boolean }) =>
  css({
    display: 'block',
    minWidth: 0,
    cursor: 'pointer',
    padding: isSelected ? '7px' : 1,
    borderRadius: 4,
    borderStyle: 'solid',
    borderWidth: isSelected ? 2 : 1,
    borderColor: isSelected ? ThemeColors.Active2 : ThemeColors.Border,
  })
);

// eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
export const IdpScopeGrid = styled('div')(
  css({
    display: 'grid',
    gridTemplateColumns: 'repeat(2, minmax(0, 1fr))',
    gap: 1,
  })
);

interface IdpScopeCardProps {
  name: string;
  value: string;
  title: string;
  description: string;
  checked: boolean;
  onSelect: (value: string) => void;
}

export const IdpScopeCard: React.VFC<IdpScopeCardProps> = ({ name, value, title, description, checked, onSelect }) => {
  const descriptionId = `${name}-${value}-description`;
  return (
    <Option isSelected={checked}>
      <Stack direction="row" itemSpacing={1} alignItems="flex-start">
        <Radio
          name={name}
          value={value}
          checked={checked}
          aria-label={title}
          aria-describedby={descriptionId}
          onChange={() => {
            onSelect(value);
          }}
        />
        <Stack direction="column" itemSpacing={0}>
          <MediumBoldText>{title}</MediumBoldText>
          <SmallSubtleText id={descriptionId}>{description}</SmallSubtleText>
        </Stack>
      </Stack>
    </Option>
  );
};
